import { Tabs } from "@jhool-io/fe-components";
import { useParams, useSearchParams } from "react-router-dom";
import ProviderCaseload from "../ProviderCaseload/ProviderCaseload";
import SuperviseeCaseload from "../SuperviseeCaseload/SuperviseeCaseload";
import {
    useFetchProvidersCaseload,
    useFetchSuperviseesCaseload,
} from "../../hooks/providers.queries";

interface CaseloadProps {
    /** Determines whether clinician is a supervisor or not */
    isSupervisor?: boolean;
}

export default function CaseloadWrapper({ isSupervisor }: CaseloadProps) {
    const [searchParams, setSearchParams] = useSearchParams();
    const params = useParams();

    const providerId = params.providerId as string;

    const searchString = searchParams.get("search") || "";

    const handleSetTabInUrl = (tab: string) => {
        searchParams.set("tab", tab);
        setSearchParams(searchParams);
    };

    const {
        data: caseloadData,
        isLoading: caseloadLoading,
        error: caseloadError,
    } = useFetchProvidersCaseload({
        providerId,
        search_string: searchString,
        enabled: Boolean(providerId),
    });

    const {
        data: superviseesData,
        isLoading: superviseesLoading,
        error: superviseesError,
    } = useFetchSuperviseesCaseload({
        providerId,
        search_string: searchString,
    });

    const tabInUrl = searchParams.get("tab");

    let clientCount;
    if (caseloadLoading) clientCount = 0;
    if (caseloadError) clientCount = 0;
    if (caseloadData) clientCount = caseloadData.data.length;

    let superviseesCount;
    if (superviseesLoading) superviseesCount = 0;
    if (superviseesError) superviseesCount = 0;
    if (superviseesData) superviseesCount = superviseesData.data.length;

    const tabItems = [
        {
            key: "provider-caseload",
            label: "Provider Caseload",
            children: <ProviderCaseload />,
            onClick: () => handleSetTabInUrl("provider-caseload"),
            count: clientCount,
        },
        {
            key: "supervisee-caseload",
            label: "Supervisees",
            children: <SuperviseeCaseload />,
            onClick: () => handleSetTabInUrl("supervisee-caseload"),
            count: superviseesCount,
        },
    ];

    return (
        <>
            {isSupervisor && (
                <Tabs
                    items={tabItems}
                    className="!w-[100%] !items-end"
                    defaultActiveKey={tabInUrl || "provider-caseload"}
                />
            )}
            {!isSupervisor && <ProviderCaseload />}
        </>
    );
}
